<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 sm12 v-for="(item, index) in reportes" :key="index">
        <v-card>
          <v-card-subtitle>
            <h3>
              Usuario que ha reportado {{ item.usuario.nombre }} - Correo
              elect.: {{ item.usuario.email }}
            </h3>
          </v-card-subtitle>
          <v-card class="mx-auto ml-4 mr-4" outlined>
            <v-card-title>
              <h3>
                Path {{ item.path }} 
              </h3>
            </v-card-title>
            <v-card-title>
              <h3>
                Número de tema {{ item.numeroTema }} - {{ item.nombreTema }}
              </h3>
            </v-card-title>

            <v-card-title>
              <h3>
                Número de test {{ item.numeroTest }} - {{ item.nombreTest }}
              </h3>
            </v-card-title>
            <v-card-title>
              <h3>
                Número de pregunta {{ item.numeroPregunta }} -
                {{ item.pregunta }}
              </h3>
            </v-card-title>
            <br />
            <v-card-subtitle>
              Respuesta A: {{ item.respuestas[0].respuesta }}
              <span
                v-if="item.respuestas[0].correcta"
                class="text-h8 green--text"
                >Respuesta correcta</span
              >
            </v-card-subtitle>
            <v-card-subtitle>
              Respuesta B: {{ item.respuestas[1].respuesta }}
              <span v-if="item.respuestas[1].correcta" class="text-h6"
                >Respuesta correcta</span
              >
            </v-card-subtitle>
            <v-card-subtitle>
              Respuesta C: {{ item.respuestas[2].respuesta }}
              <span v-if="item.respuestas[2].correcta" class="text-h6"
                >Respuesta correcta</span
              >
            </v-card-subtitle>
            <v-card-subtitle>
              Respuesta D: {{ item.respuestas[3].respuesta }}
              <span v-if="item.respuestas[3].correcta" class="text-h6"
                >Respuesta correcta</span
              >
            </v-card-subtitle>
          </v-card>
          <v-card class="mx-auto ml-4 mr-4" outlined>
            <v-card-title outlined color="red"> Reporte: </v-card-title>
            <v-card-subtitle>
              {{ item.textoReporte }}
            </v-card-subtitle>
          </v-card>

          <v-card-actions>
            <v-btn @click="deleteReport(item.id)" color="info" text>
              Eliminar
            </v-btn>
              <v-btn @click="editarPregunta(item.path)" color="info" text>
              Editar pregunta
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialogMoreInfo" persistent>
      <v-card>
        <v-card-title> Lorem, ipsum dolor. </v-card-title>
        <v-card-text>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Qui et
          tenetur officiis commodi optio voluptatibus, saepe facilis, iure error
          molestiae velit dolores mollitia accusantium sed voluptatem sunt
          suscipit. Nam, tenetur!
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-center">
          <v-btn @click="dialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogEdit" max-width="600px">
            <v-card v-if="dialogEdit">
              <v-card-title>
                <span class="headline">Editar pregunta</span>
              </v-card-title>

              <v-card-text>
                <v-container fill-height>
                  <v-row align="center" justify="center">
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        v-model="preguntaEdited.pregunta"
                        required
                        label="Pregunta"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field
                        v-model="preguntaEdited.respuestas[0].respuesta"
                        required
                        label="Respuesta A"
                      ></v-text-field>
                      <v-text-field
                        v-model="preguntaEdited.respuestas[1].respuesta"
                        required
                        label="Respuesta B"
                      ></v-text-field>
                      <v-text-field
                        v-model="preguntaEdited.respuestas[2].respuesta"
                        required
                        label="Respuesta C"
                      ></v-text-field>
                      <v-text-field
                        v-model="preguntaEdited.respuestas[3].respuesta"
                        required
                        label="Respuesta D"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6" sm="6">
                      <v-row>
                        <v-switch
                          v-model="preguntaEdited.shuffle"
                          required
                          label="Desordenar respuestas"
                        ></v-switch>
                        <v-select
                          v-model="preguntaEdited.respuestaCorrecta"
                          required
                          :items="items"
                          label="Respuesta Correcta"
                        ></v-select>
                         <v-textarea
                        @keyup.enter.native="agregarPreguntaSinSalir"
                        v-model="preguntaEdited.explicacion"
                        required
                        label="Explicación"
                      ></v-textarea>
                      </v-row>
                    </v-col>

                  
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="blue darken-1" text @click="closeEdit"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="saveEditItem()"
                  >Guardar</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
           <v-snackbar v-model="snackbar">
      {{ mensaje }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { firebase, db, auth } from "@/firebase";

export default {
  components: {},
  methods: {
    ...mapActions([
      "cerrarSesion",
      "loadReportes",
      "deleteReport",
      "setLoadingTrue",
      "loadPreguntaPorPath",
      "savePreguntaEdited"
    ]),
    editarPregunta(path){
      this.dialogEdit = true
      this.pathTemp = path
      this.loadPreguntaPorPath(path)
    },
    closeEdit(){
      this.dialogEdit = false
    },
    async saveEditItem(){
      await this.savePreguntaEdited(this.pathTemp)
      this.dialogEdit = false
      this.pathTemp = ""
      if (this.preguntaEdited = {}){
           this.snackbar = true
      this.mensaje = "Pregunta editada con éxito"
      }
   
    }
  },

  created() {
    this.loadReportes();
  },

  data() {
    return {
      reporte: {},
      dialog: false,
      dialogEdit: false,
      dialogMoreInfo: false,
      imageData: null,
      picture: null,
      uploadValue: 0,
          items: ["A", "B", "C", "D"],
      pathTemp : "",
      snackbar: false,
    mensaje: "",
    };
  },
  computed: {
    ...mapState(["usuario", "reportes", "loading", "preguntaEdited"]),
  },
};
</script>
